import { components } from "@/api-schema";
import { DataTableRow } from "@/components/data-table/types";
import { BuildingIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

type Vehicle = components["schemas"]["Vehicle"];

export interface VehicleSubComponentProps {
  row: DataTableRow<Vehicle>;
}

export function VehicleSubComponent({ row }: VehicleSubComponentProps) {
  const { t } = useTranslation("common");
  const vehicle = row.original;
  const owningBranch = vehicle.owningBranch;

  const label = owningBranch ? owningBranch.name : null;

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {owningBranch && label && (
        <div className="border-border bg-background flex h-fit items-center gap-3 rounded-lg border p-3">
          <div className="bg-primary/10 flex h-10 w-10 items-center justify-center rounded-full">
            <BuildingIcon className="text-primary h-5 w-5" />
          </div>
          <div className="flex-1">
            <div className="text-muted-foreground text-xs">{t("common:OwningBranch")}</div>
            <div className="font-semibold">{label}</div>
          </div>
        </div>
      )}
    </div>
  );
}
